module.exports = __webpack_public_path__ + "static/underground-skilti-a59e8a21952a6b8933c1e4e30cb6e351.png";